module.exports = ".action-buttons {\n  text-align: right; }\n\n.spacing-left {\n  margin-left: 16px; }\n"